import React, { PropsWithChildren } from 'react'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { initialiseLaunchpadAnalytics } from '@moonpig/web-core-analytics'

const SearchAnalyticsContext = React.createContext(false)
export const useSearchAnalytics = () => React.useContext(SearchAnalyticsContext)

export const SearchAnalyticsProvider = ({
  children,
  enabled: override,
}: PropsWithChildren<{ enabled?: boolean }>) => {
  const variant = useExperiment('enablement-web-launchpad-analytics-search', {
    fallback: 'control',
  })
  const enabled = override ?? variant === 'variant'
  if (enabled) initialiseLaunchpadAnalytics()
  return (
    <SearchAnalyticsContext.Provider value={enabled}>
      {children}
    </SearchAnalyticsContext.Provider>
  )
}

export const sanitizeContentType = (value: string) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9&'’\-|/_!?>% ]/g, '')
    .substring(0, 100)
